import type { ActualiteDTO } from '@/features/api/extranet/dto/shared'
import { useFetch } from '@/features/fetch'

export async function loadActualites(init?: RequestInit): Promise<ActualiteDTO[] | null> {
  if (!init) init = { sablier: false, dialogMode: 'silent' }

  const fetch = useFetch('base')

  const url = import.meta.env.VITE_RESSOURCES_STATIQUES + '/content/actualites.json'

  const response = await fetch(url, init)

  const result = (await response.json()) as ActualiteDTO[]

  return result?.sort((a, b) => (new Date(a.date!) > new Date(b.date!) ? -1 : 1)).slice(0, 4)
}
